const IMAGE_HANDLER_BASE_URL = import.meta.env.VITE_IMAGE_HANDLER_URL || 'https://d3melzkv2c4868.cloudfront.net';

export interface ImageOptions {
  key: string;
  width?: number;
  height?: number;
  fit?: 'cover' | 'contain' | 'fill' | 'inside' | 'outside';
  format?: 'jpeg' | 'png' | 'webp';
  quality?: number;
}

export function createAlyzeOptimizedImageUrl(options: ImageOptions): string {
  const { key, width, height, fit = 'cover', format, quality = 80 } = options;
  
  const imageRequest: any = {
    bucket: 'alyze-store-images',
    key: key,
    edits: {}
  };
  
  // Add resize if dimensions provided
  if (width || height) {
    imageRequest.edits.resize = {
      width,
      height,
      fit
    };
  }
  
  // Add format conversion
  if (format) {
    imageRequest.edits[format] = {
      quality
    };
  }
  
  const encodedRequest = btoa(JSON.stringify(imageRequest));
  return `${IMAGE_HANDLER_BASE_URL}/${encodedRequest}`;
}
